(function () {
  'use strict';
  var collectionFilterBar;

  function markActiveCollectionLink() {
    var currentPath = window.location.pathname.replace(/\/$/, '');
    var collectionPaths = {
      '/collections/cercei-din-argint': '/collections/cercei',
      '/collections/colier-din-argint': '/collections/coliere',
      '/collections/bratara-din-argint': '/collections/bratari'
    };

    document.querySelectorAll('.ayla-filter-links a').forEach(function (link) {
      var linkPath = new URL(link.href, window.location.origin).pathname.replace(/\/$/, '');
      if (collectionPaths[linkPath]) {
        linkPath = collectionPaths[linkPath];
        link.setAttribute('href', linkPath);
      }
      var isCurrent = linkPath === currentPath;

      link.classList.toggle('is-active', isCurrent);

      if (isCurrent) {
        link.setAttribute('aria-current', 'page');
      } else {
        link.removeAttribute('aria-current');
      }
    });
  }

  function mountProductPromise() {
    var source = document.querySelector('[data-ayla-product-promise-source]');
    var promise = source && source.querySelector('.ayla-product-promise');
    var addToCartForm = document.querySelector('.template-product main form[action*="/cart/add"]');

    if (!promise || !addToCartForm || promise.dataset.aylaMounted === 'true') return;

    var view = addToCartForm.closest('.productView');
    var gift = view && view.querySelector('.productView-details ayla-gift-wrap');
    var target = gift || addToCartForm.closest('.productView-moreItem') || addToCartForm;
    target.insertAdjacentElement(gift ? 'beforebegin' : 'afterend', promise);
    promise.dataset.aylaMounted = 'true';
  }

  function updateProductPromise(event) {
    var promise = document.querySelector('.ayla-product-promise[data-ayla-mounted]');
    if (!promise) return;
    var view = promise.closest('.productView');
    var picker = view && view.querySelector('variant-selects, variant-radios');
    if (!picker || !('currentVariant' in picker)) return;
    if (event && !view.contains(event.target)) return;
    var available = Boolean(picker.currentVariant && picker.currentVariant.available);
    promise.dataset.available = String(available);
    promise.querySelector('[data-ayla-availability]').textContent = available ? promise.dataset.availableLabel : promise.dataset.unavailableLabel;
    promise.querySelector('[data-ayla-processing]').textContent = available ? promise.dataset.processing : promise.dataset.unavailableNote;
  }

  function init() {
    mountCollectionToolbar();
    markActiveCollectionLink();
    mountProductPromise();
    updateProductPromise();
  }

  function protectMobilePurchaseControls() {
    if (!window.customElements) return;
    customElements.whenDefined('gty-whatsapp-chat-button').then(function() {
      document.querySelectorAll('gty-whatsapp-chat-button').forEach(function(host) {
        var root = host.shadowRoot;
        if (!root || root.querySelector('[data-ayla-mobile-clearance]')) return;
        var style = document.createElement('style');
        style.dataset.aylaMobileClearance = 'true';
        style.textContent = '@media(max-width:1024px){.gty-wacb-wrapper{bottom:var(--ayla-contact-bottom,calc(92px + env(safe-area-inset-bottom,0px)))!important;right:12px!important;left:auto!important}}';
        root.appendChild(style);
        var purchase = document.querySelector('#product-add-to-cart');
        if (purchase && window.IntersectionObserver && window.matchMedia) {
          var mobile = window.matchMedia('(max-width:1024px)');
          var purchaseVisible = false;
          var updateContactVisibility = function() {
            host.style.visibility = mobile.matches && purchaseVisible ? 'hidden' : '';
          };
          var purchaseObserver = new window.IntersectionObserver(function(entries) {
            purchaseVisible = entries.some(function(entry) { return entry.isIntersecting; });
            updateContactVisibility();
          });
          purchaseObserver.observe(purchase);
          mobile.addEventListener('change', updateContactVisibility);
        }
      });
    });
  }

  if (window.customElements && typeof MutationObserver === 'function') {
    var contactObserver = new MutationObserver(function(records) {
      if (records.some(function(record) {
        return Array.from(record.addedNodes).some(function(node) {
          return node.nodeType === 1 && (node.matches('gty-whatsapp-chat-button') || node.querySelector('gty-whatsapp-chat-button'));
        });
      })) protectMobilePurchaseControls();
    });
    contactObserver.observe(document.documentElement, { childList: true, subtree: true });
    protectMobilePurchaseControls();
  }

  function mountCollectionToolbar() {
    var slot = document.querySelector('.ayla-native-filter-slot');
    if (slot && !slot.aylaFilterObserver) {
      slot.aylaFilterObserver = new MutationObserver(function() { mountCollectionToolbar(); });
      slot.aylaFilterObserver.observe(slot, { childList: true, subtree: true });
    }
    var form = slot && slot.querySelector('#CollectionFiltersForm');
    var component = document.querySelector('collection-filters-form');
    if (form && component && !form.closest('collection-filters-form')) {
      component.classList.remove('ayla-filter-source-shell');
      component.appendChild(form);
      slot.appendChild(component);
    }
    var priceData = document.querySelector('#AylaCollectionPrice');
    if (form && priceData) {
      var maximum = Number(priceData.dataset.max);
      form.querySelectorAll('price-range').forEach(function(range) {
        if (range.aylaPriceReady || !Number.isFinite(maximum) || maximum <= 0) return;
        range.aylaPriceReady = true;
        var params = new URLSearchParams(window.location.search);
        range.querySelectorAll('input[type="range"], input[type="number"]').forEach(function(input) {
          input.max = String(maximum);
          var isMaximum = input.classList.contains('filter__price_max') || input.classList.contains('filter__price--max');
          var parameter = isMaximum ? 'filter.v.price.lte' : 'filter.v.price.gte';
          var currentValue = params.get(parameter);
          if (input.type === 'range') input.value = currentValue || (isMaximum ? String(maximum) : '0');
          else { input.value = currentValue || ''; input.placeholder = isMaximum ? String(maximum) : '0'; }
        });
      });
    }
    var grid = document.querySelector('#CollectionProductGrid');
    var filterBar = document.querySelector('.ayla-filter-bar') || collectionFilterBar;
    var toolbar = grid && grid.querySelector('toolbar-item');
    if (!toolbar || !filterBar) return;
    collectionFilterBar = filterBar;
    if (filterBar.parentElement !== toolbar) toolbar.prepend(filterBar);
    var products = grid.querySelector('#main-collection-product-grid');
    if (products) { products.classList.remove('productList'); products.classList.add('productGrid'); }
    if (!grid.aylaToolbarObserver) {
      grid.aylaToolbarObserver = new MutationObserver(function() { mountCollectionToolbar(); });
      grid.aylaToolbarObserver.observe(grid, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('change', updateProductPromise);
})();
